import { render, staticRenderFns } from "./btnGroupControl.vue?vue&type=template&id=4895e194&scoped=true&"
import script from "./btnGroupControl.vue?vue&type=script&lang=js&"
export * from "./btnGroupControl.vue?vue&type=script&lang=js&"
import style0 from "./btnGroupControl.vue?vue&type=style&index=0&id=4895e194&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4895e194",
  null
  
)

export default component.exports